import { CustomField } from "./customField";
import { REGEX, testRegex } from "@/backend/lib/regex";

export class FloatCustomField extends CustomField {
  formatFromRead(): void {
    this.customValue = parseFloat(this.customValue as string);
    if (Number.isNaN(this.customValue)) {
      this.customValue = undefined;
    }

    const parsedDefaultValue = parseFloat(this.defaultValue as string);
    if (!Number.isNaN(parsedDefaultValue)) {
      this.defaultValue = parsedDefaultValue;
    }
  }

  hasValidDefaultInput() {
    if (this.defaultValue === undefined || this.defaultValue === null) return true;
    return testRegex(REGEX.float, this.defaultValue.toString());
  }

  hasValidCustomInput() {
    if (this.customValue === undefined || this.customValue === null) return true;
    return testRegex(REGEX.float, this.customValue.toString());
  }
}
